import React, {useState} from 'react';
import ModalWrapper from '../ModalWrapper';
import ModalAccessoriesBody from './ModalAccessoriesBody';
import ModalAccessoryDetailBody from './ModalAccessoryDetailBody';

import useAccessoriesData from '../../../hooks/useAccessoriesData';

const ModalAccessories = ({isOpen, onCloseModal}) => {

    const { getSelectedAccessory } = useAccessoriesData();

    const selectedAccesory = getSelectedAccessory();

    const defaultModalProperties = {
        onCloseModal: () => onCloseModal()
    }

    const CurrentModal = () => {
        if (!selectedAccesory) {
            return <ModalAccessoriesBody {...defaultModalProperties}/>
        }
        else {
            return <ModalAccessoryDetailBody {...defaultModalProperties} accessory={selectedAccesory}/>
        }
    };

    return (
        <ModalWrapper isOpen={isOpen} cssClass="modal-accessory-detail">
            {CurrentModal()}
        </ModalWrapper>
    )
}

export default ModalAccessories;